/**
 * Domain Configuration
 *
 * Controls domain-specific behavior based on REACT_APP_DOMAIN_MODE env variable.
 *
 * Usage:
 *   - Set REACT_APP_DOMAIN_MODE=default for glass-railing.com (shows prices, default French)
 *   - Set REACT_APP_DOMAIN_MODE=reseller for reseller domain (hides prices, default English)
 *
 * In Vercel, set this in Project Settings > Environment Variables
 */

export type DomainMode = "default" | "reseller";

const domainMode: DomainMode =
  (process.env.REACT_APP_DOMAIN_MODE as DomainMode) || "default";

export const domainConfig = {
  /** Current domain mode */
  mode: domainMode,

  /** Whether to show prices in the UI */
  showPrices: true,

  /** Whether this is the reseller domain */
  isReseller: domainMode === "reseller",

  /** Default language for this domain */
  defaultLanguage: domainMode === "reseller" ? "en" : "fr",

  /** Default province for this domain */
  defaultProvince: domainMode === "reseller" ? "ONTARIO" : "QUEBEC",
} as const;

export default domainConfig;
